export default "__VITE_ASSET__BcTDrYtd__"